/**
 * StatCard Component
 * 
 * Display card for overview statistics in the admin dashboard.
 * Shows a large number with title and optional subtitle.
 */

import React from 'react';
import { typography, surfaces, borders, textColors, brandColors } from '../../design-system/tokens';
import { formatNumber } from '../utils/chartHelpers';

const StatCard = ({ title, value, subtitle, icon }) => {
  const isNumber = typeof value === "number" && Number.isFinite(value);
  const renderedValue = isNumber ? formatNumber(value) : value;
  return (
    <div className={`${surfaces.glassCard} ${borders.glass} border rounded-2xl p-6 shadow-sm`}>
      {/* Optional Icon */}
      {icon && (
        <div className={`mb-3 flex items-center justify-center w-12 h-12 ${brandColors.primaryBgLight} rounded-lg`}>
          {icon}
        </div>
      )}
      
      {/* Title */}
      <h3 className={`${typography.h5} ${textColors.tertiary} mb-2`}>
        {title}
      </h3>
      
      {/* Large Value */}
      <div className={`${typography.h1} ${textColors.primary} mb-1`}>
        {renderedValue}
      </div>
      
      {/* Optional Subtitle */}
      {subtitle && (
        <p className={`${typography.caption} ${textColors.muted}`}>
          {subtitle}
        </p>
      )}
    </div>
  );
};

export default StatCard;

